<script>
import {defineComponent} from 'vue'
import {Swiper, SwiperSlide} from 'swiper/vue'
import {Navigation, Pagination, Autoplay} from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import PopularProductBannerItem from "@js/components/Sections/Home/Components/PopularProductBannerItem.vue"
import IconAngleLeft from "@js/components/Icons/IconAngleLeft.vue"

import img_1 from '@img/popular_banners/1.webp'
import img_2 from '@img/popular_banners/2.webp'
import img_3 from '@img/popular_banners/3.webp'
import img_4 from '@img/popular_banners/4.webp'
import img_5 from '@img/popular_banners/5.webp'
import img_6 from '@img/popular_banners/6.webp'

export default defineComponent({
    name: "PopularProductBanners",

    components: {
        Swiper,
        SwiperSlide,
        PopularProductBannerItem,
        IconAngleLeft,
    },

    data() {
        return {
            swiper: null,

            breakpoints: {
                320: {slidesPerView: 1.12, spaceBetween: 12},
                640: {slidesPerView: 2.1, spaceBetween: 16},
                768: {slidesPerView: 2, spaceBetween: 20},
                1024: {slidesPerView: 4, spaceBetween: 20},
            },

            banners: [
                {
                    title: 'Железобетонные изделия',
                    description: 'Надёжные решения для строительства любой сложности',
                    img: img_1,
                    link: route('catalog',{type_slug: 'zhbi'}),
                },
                {
                    title: 'Бетонные смеси',
                    description: 'Качественный бетон для долговечного результата',
                    img: img_2,
                    link: route('catalog',{type_slug: 'beton'}),
                },
                {
                    title: 'Пиломатериалы',
                    description: 'Натуральная древесина для строительства и отделки',
                    img: img_3,
                    link: route('catalog',{type_slug: 'pilomaterialy'}),
                },
                {
                    title: 'Тротуарная плитка',
                    description: 'Эстетика и долговечность для дорожек и территорий',
                    img: img_4,
                    link: route('catalog',{type_slug: 'trotuarnaya_plitka'}),
                },
                {
                    title: 'Нерудные материалы',
                    description: 'Основа для стройки: песок, щебень и сыпучие материалы',
                    img: img_5,
                    link: route('comingSoon'),
                },
                {
                    title: 'Строительные конструкции',
                    description: 'Готовые решения для быстрого и эффективного монтажа',
                    img: img_6,
                    link: route('comingSoon'),
                },
            ],
        }
    },

    methods: {
        setSwiper(swiperInstance) {
            this.swiper = swiperInstance
        },

        slideNext() {
            this.swiper?.slideNext()
        },

        slidePrev() {
            this.swiper?.slidePrev()
        },
    },

    setup() {
        return {
            modules: [Navigation, Pagination, Autoplay],
        }
    },
})
</script>

<template>
    <div class="popular-product-banners">
        <!-- MOBILE -->
        <div class="block lg:hidden">
            <Swiper
                :modules="modules"
                :slides-per-view="1.12"
                :space-between="12"
                :breakpoints="breakpoints"
                :loop="banners.length > 2"
                :autoplay="{ delay: 5000, disableOnInteraction: false }"
                @swiper="setSwiper"
                class="pagination-base long_bullet h-full"
            >
                <SwiperSlide
                    v-for="banner in banners"
                    :key="banner.title"
                    class="rounded-lg overflow-hidden"
                >
                    <PopularProductBannerItem v-bind="banner" />
                </SwiperSlide>
            </Swiper>

            <div class="flex items-end justify-between mt-5">
                <div class="hidden md:flex gap-3">
                    <button
                        v-if="swiper"
                        @click.prevent="slidePrev"
                        class="bg-baseColor rounded-full w-[44px] h-[44px] flex items-center justify-center"
                    >
                        <IconAngleLeft class="w-5 h-5"/>
                    </button>

                    <button
                        v-if="swiper"
                        @click.prevent="slideNext"
                        class="bg-baseColor rounded-full w-[44px] h-[44px] flex items-center justify-center"
                    >
                        <IconAngleLeft class="w-5 h-5 rotate-180"/>
                    </button>
                </div>
            </div>
        </div>

        <!-- DESKTOP -->
        <div class="hidden lg:grid grid-cols-1 gap-5">
            <!-- TOP -->
            <div class="grid grid-cols-2 gap-5">
                <PopularProductBannerItem v-bind="banners[0]" />

                <div class="grid grid-cols-2 gap-5">
                    <PopularProductBannerItem v-bind="banners[1]" />
                    <PopularProductBannerItem v-bind="banners[2]" />
                </div>
            </div>

            <!-- BOTTOM -->
            <div class="grid grid-cols-2 gap-5">
                <div class="grid grid-cols-2 gap-5">
                    <PopularProductBannerItem v-bind="banners[3]" />
                    <PopularProductBannerItem v-bind="banners[4]" />
                </div>

                <PopularProductBannerItem v-bind="banners[5]" />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.popular-product-banners {
    overflow: hidden;
}
</style>
